/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * TM - trade mark. В данные момент пока только TM
 * @export
 * @enum {string}
 */
export enum ApplicationType {
  Tm = 'TM',
  TmApplication = 'TMApplication',
}

export function instanceOfApplicationType(value: any): boolean {
  for (const key in ApplicationType) {
    if (Object.prototype.hasOwnProperty.call(ApplicationType, key)) {
      if (ApplicationType[key as keyof typeof ApplicationType] === value) {
        return true
      }
    }
  }
  return false
}

export function ApplicationTypeFromJSON(json: any): ApplicationType {
  return ApplicationTypeFromJSONTyped(json, false)
}

export function ApplicationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationType {
  return json as ApplicationType
}

export function ApplicationTypeToJSON(value?: ApplicationType | null): any {
  return value as any
}
